// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__JUkHe","formWrapper":"style_formWrapper__9f0AZ","form":"style_form__szZmu","logo":"style_logo__JNW62"};